<template src="../templates/groupList.html">

</template>

<script>
    import GroupItem from "../components/GroupItem";
    import Config from "../config/config";

    export default {
        name: "GroupList",
        components: {GroupItem},
        data() {
            return {
                isAdmin: false,
                groupModelList: [],
                availableAccessPoints: [],
                newGroupModel: {},
                newGroupVisible: false
            }
        },
        methods: {
            isEditable() {
                return this.isAdmin;
            },
            addGroup() {
                let self = this;
                let url = `${this.$localApiURL}group/addEditGroup`;
                this.$http.post(url, {
                    token: localStorage.getItem("jwt"),
                    group: this.newGroupModel
                }).then(res => {
                    self.getGroupList();
                }).catch(function (error) {
                    console.log(error);
                });
                this.newGroupVisible = false;

            },
            cancelNewGroup() {
                this.newGroupVisible = false;
            },
            newGroup() {
                this.loadNewDialog();
                this.newGroupModel = {
                    clientAccessGroupId: "",
                    name: "",
                    isAdmin: false,
                    numericIdentifier: "",
                    active: true,
                    itProjectId: Config.projectId
                };

            },
            getGroupList() {
                let url = `${this.$localApiURL}groups/getAvailableGroups/${Config.projectId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    self.groupModelList = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getAvailableAccessPoints() {
                let url = `${this.$localApiURL}accessPoints/get/${Config.projectId}`;
                let self = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {
                    self.availableAccessPoints = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            loadNewDialog() {
                this.newGroupVisible = true;
            }
        },
        created() {
            this.isAdmin = localStorage.getItem("isAdmin") === "true";
            this.getGroupList();
            this.getAvailableAccessPoints();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/GroupList.vue